import { Skeleton } from './Skeleton'

interface SkeletonGridProps {
  count?: number
  columns?: number
  aspectRatio?: string
  className?: string
}

export function SkeletonGrid({
  count = 4,
  columns = 4,
  aspectRatio = '3/4',
  className,
}: SkeletonGridProps) {
  const colsClass =
    columns === 2
      ? 'grid-cols-2'
      : columns === 3
        ? 'grid-cols-2 md:grid-cols-3'
        : 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4'

  return (
    <div className={`grid gap-4 ${colsClass} ${className ?? ''}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="space-y-3">
          <Skeleton className="w-full" style={{ aspectRatio }} />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
      ))}
    </div>
  )
}
